import React from "react";
import { toJS } from "mobx";
import FormField from "@modules/formx-react/FormField";
import locale from "@bonliva-crm/locale";
import { toOptionArray, Options } from "./utils";
import InnerSelect, { AnySelectProps, MultiSelectProps, Option } from "../Select";

export { Options, Option };

export type SelectProps = {
  creatable?: boolean;
  clearable?: boolean;
  disabled?: boolean;
  innerRef?: React.Ref<any>;
  fullWidth?: boolean;
  id?: string;
  label?: string;
  multi?: boolean;
  name: string;
  nested?: boolean;
  options: Options;
  plain?: boolean;
  placeholder?: string;
  error?: boolean;
  renderDescriptionInValues?: boolean;
  required?: boolean;
  sortOptions?: AnySelectProps["sortOptions"];
  sortValues?: MultiSelectProps["sortValues"];
  transformValue?: AnySelectProps["transformValue"];
  optionRenderer?: AnySelectProps["optionRenderer"];
  helperText?: MultiSelectProps["helperText"];
};

export const Select: React.FC<SelectProps> = (props) => {
  return (
    <FormField name={props.name}>
      {(field) => {
        const { options, label } = props;

        const o: any = {
          // <-- The typing for select seems insane :O
          clearable: props.clearable,
          creatable: props.creatable,
          error: field.invalid || props.error,
          fullWidth: typeof props.fullWidth === "boolean" ? props.fullWidth : true,
          innerRef: props.innerRef,
          label: field.error || locale.SelectSomething(label),
          multi: props.multi,
          nested: props.nested,
          options: toOptionArray(options),
          optionType: props.multi ? "checkbox" : undefined,
          optionRenderer: props.optionRenderer,
          placeholder: props.placeholder,
          plain: props.plain,
          renderDescriptionInValues: props.renderDescriptionInValues,
          resetValue: props.multi ? null : "",
          required: props.required,
          sortOptions: props.sortOptions,
          sortValues: props.sortValues,
          transformValue: props.transformValue,
          ...field.fieldProps,
          // formx sets field disabled when the form is fully disabled
          // so we have to check both `disabled` options here
          disabled: field.fieldProps.disabled || props.disabled,
          value: toJS(field.fieldProps.value),
          helperText: props?.helperText || ""
        };
        return <InnerSelect {...o} />;
      }}
    </FormField>
  );
};

export default Select;
